<template>
  <div>
    <div style="margin-top: 20px;">
      <el-table :data="listData">
        <el-table-column align="center" label="" prop="docker" width="60px">
          <template v-slot="{row}">
            <div v-if="row.isDocker && row.moduleMode!=0" style="width:40px;height: 65px;">
              <img src="@/assets/docker.png" style="
                   margin-bottom: -28px;width:25px;height: 25px;">
            </div>
            <div v-else-if="!row.isDocker && row.moduleMode==0" style="width:40px;height: 65px;">
              <img src="@/assets/butel.png" style="
                   width:40px;height: 40px;margin-top: 13px">
            </div>
            <div v-else style="width:40px;height: 65px;">
              <img src="@/assets/docker.png" style="vertical-align: center;width:25px;height: 25px;">
              <img src="@/assets/butel.png" style="vertical-align: center;
                   width:40px;height: 40px;">
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="" width="30px" prop="onlineInstanceId">
          <template v-slot="{row}">
            <div v-if="row.isOnline">
              <img src="@/assets/run.gif" style="width: 25px;height: 25px;margin-top: 10px">
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="实例ID_服务ID" width="120px">
          <template v-slot="{row}">
            {{ row.id }}_{{ row.service.id }}
          </template>
        </el-table-column>
        <el-table-column align="center" property="startStatus" label="启动状态" width="80px">
          <template v-slot="{row}">
            <i
              class="el-icon-sunny statusIcon"
              title="已启动"
              style="color:#67C23A;"
              v-if="row.service.status.operation.start == 1 &&
                    row.service.status.operation.stop != 2"
            ></i>
            <i
              class="el-icon-sunset statusIcon"
              title="已停止"
              style="color:rgb(247, 210, 103);"
              v-if="row.service.status.operation.stop == 1
                    || (row.service.status.operation.install == 1
                        && row.service.status.operation.stop == -1
                        && row.service.status.operation.start == -1)"
            ></i>
            <i
              class="el-icon-lightning statusIcon"
              :title="row.service.status.operation.start == 2 ?'启动失败':'停止失败'"
              style="color:rgb(245, 108, 108);"
              v-if="row.service.status.operation.start == 2
              || row.service.status.operation.stop == 2"
            ></i>
            <i
              class="el-icon-loading statusIcon"
              :title="row.service.status.operation.start == 0?'正在启动':'正在停止'"
              style="color:#66b1ff;"
              v-if="row.service.status.operation.start== 0
              || row.service.status.operation.stop == 0"
            ></i>
          </template>
        </el-table-column>
        <el-table-column align="center" property="heartStatus" label="心跳状态" width="80px">
          <template v-slot="{row}">
            <img
              src="@/assets/u881.png"
              style="vertical-align: middle;"
              v-if="row.service.status.operation.heartbeat == 1"/>
            <img src="@/assets/u883.png" style="vertical-align: middle;" v-else/>
          </template>
        </el-table-column>
        <el-table-column align="center" property="alias" label="别名"></el-table-column>
        <el-table-column align="center" property="deviceName" label="设备名称"></el-table-column>
        <el-table-column align="center" property="moduleType" label="模块类型"></el-table-column>
        <el-table-column align="center" property="moduleVersion" label="模块版本"></el-table-column>
        <el-table-column align="center" label="状态描述" :formatter="statusDesc"
                         show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="结果描述" show-overflow-tooltip>
          <template v-slot="{row}">
            {{ row.service.status.description }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="450" v-if="listOperations.length > 0">
          <template v-slot="{row}">
            <el-button type="danger" size="mini" @click="restartAgent(row)"
                       v-if="btnInList('instance_restart') && row.moduleType=='service_agent' && row.isOnline">
              重启
            </el-button>

            <span :disabled="row.isDocker">
            <el-button type="primary" size="mini" @click="getDockerState(row)"
                       v-if="row.isDocker && btnInList('instance_docker') " :loading="row.createLoading">创建容器
            </el-button>
            <el-button type="warning" size="mini" style="margin:0 10px;"
                       v-if="btnInList('instance_upgrade') && row.moduleType != 'service_agent'"
                       @click="coverStart(row)">增量升级
            </el-button>
            <div v-if="!fromPath.startsWith('/monitor')" style="display: inline-block;margin-left: 10px">
              <el-button type="primary" size="mini"

                         v-if="btnInList('instance_detect') && row.moduleType != 'service_agent'"
                         @click="detectBeforeStart(row)">探测
              </el-button>
              <el-button
                v-if="btnInList('instance_stop')
                  && (row.service.status.operation.start == 1
                    || row.service.status.operation.stop == 2)
                  && row.moduleType != 'service_agent'"
                :disabled="row.service.status.operation.stop == 0 ||  row.service.serviceMode === false"
                size="mini"
                type="primary"
                @click="start( row, 'stop')">停止
              </el-button>
              <el-button
                v-if="btnInList('instance_start')  && (
                  (row.service.status.operation.install == 1 && row.service.status.operation.start == -1)
                  || row.service.status.operation.stop == 1
                  || row.service.status.operation.start == 2) && row.moduleType != 'service_agent'"
                :disabled="row.service.status.operation.start == 0 ||  row.service.serviceMode === false "
                size="mini"
                type="primary"
                @click="start( row, 'start')">启动
              </el-button>
              <!-- <el-button
                v-if="btnInList('restart') && row.service.status.operation.start == 1
                 && row.moduleType != 'service_agent'"
                :disabled="row.service.restart"
                size="mini"
                type="primary"
                @click="start( row, 'restart')"
              >重启
              </el-button> -->

              <!--              <el-button-->
              <!--                :disabled="(-->
              <!--                        row.service.status.operation.heartbreak ==0-->
              <!--                        || row.service.status.operation.start == 0-->
              <!--                        || row.service.status.operation.stop == 0-->
              <!--                        || row.service.serviceMode === false-->
              <!--                        || row.moduleType.toLowerCase().startsWith('tomcat') )"-->
              <!--                v-if="btnInList('instance_heartBreak')-->
              <!--               && (row.service.status.operation.heartbeat == 1 || row.service.status.operation.heartbreak == 2)-->
              <!--               && row.moduleType != 'service_agent' && !row.hasServiceHelper"-->
              <!--                size="mini" type="primary"-->
              <!--                @click="start( row, 'disconnect')">心跳中断-->
              <!--              </el-button>-->
              <!--              <el-button-->
              <!--                :disabled="row.service.status.operation.heartbeat == 0-->
              <!--                        || row.service.status.operation.start == 0-->
              <!--                        || row.service.status.operation.stop == 0-->
              <!--                        || row.service.serviceMode === false-->
              <!--                        || row.moduleType.toLowerCase().startsWith('tomcat')-->
              <!--                        || row.heartbeatDisabled "-->
              <!--                v-if="btnInList('instance_heartConnect') && row.service.status.operation.start == 1 && !row.hasServiceHelper && (-->
              <!--                   row.service.status.operation.heartbeat == -1-->
              <!--                 ||  row.service.status.operation.heartbeat == 2-->
              <!--                 ||  row.service.status.operation.heartbreak == 1-->
              <!--              ) &&  row.moduleType != 'service_agent'"-->
              <!--                size="mini"-->
              <!--                type="primary"-->
              <!--                @click="start( row, 'connect')">心跳连接-->
              <!--              </el-button>-->
              <el-dropdown v-if="btnInList('instance_configList')"
                           style="margin:0 10px;" @command="handleCommand">
                <el-button type="primary" size="mini">
                  配置文件
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{row: row, type: '1'}">管理中心
                  </el-dropdown-item>
                  <el-dropdown-item :command="{row: row, type: '2'}">远端
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <el-button v-if="btnInList('instance_log')" style="margin-top: 5px;margin-left: 5px;"
                       size="mini"
                       type="primary"
                       @click="showLogSummary(row)">提取日志
            </el-button>
            <el-button
              v-if="btnInList('instance_copy') && row.moduleType != 'service_agent' && !row.isDocker"
              style="margin-top: 5px;"
              size="mini"
              type="primary"
              @click="copyInstance(row)">复制
            </el-button>
            <el-button
              v-if="btnInList('instance_sync')" size="mini" type="primary"
              @click="syncToV3( row )">同步
            </el-button>
              </span>
            <el-button style="margin-left: 5px;margin-top: 5px"
                       v-if="row.moduleType!='service_agent' && btnInList('instance_task')"
                       size="mini" type="primary" @click="addTask(row)">添加定时任务
            </el-button>
            <el-button style="margin-left: 5px;margin-top: 5px"
                       v-if="row.isDocker && btnInList('instance_defaultPort')"
                       size="mini" type="primary" @click="defaultPort(row)">默认端口
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="fy"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10,30,50,80]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElement"
    ></el-pagination>

    <!-- 实例视图-配置文件-->
    <el-dialog
      title="配置文件列表"
      v-if="showConfig"
      :visible="showConfig"
      @close="showConfig=false"
      width="80%">
      <config-list :moduleInfo="currentRow"
                   :instanceid="currentRow.id"
                   :type="type"
                   :docker="docker"
                   :start="currentRow.start"
                   :serviceName="currentRow.serviceName"
                   :displayByType="type == 2 && currentRow.hasServiceHelper ? true : false"/>

    </el-dialog>

    <el-dialog
      title="日志文件列表"
      v-if="showLog"
      :visible="showLog"
      @close="showLog=false"
      width="80%">
      <log-list :instanceId="log.instanceId" :serviceId="log.serviceId"
                :deviceId="log.deviceId"
                :moduleType="log.moduleType"
                :moduleVersion="log.moduleVersion"/>
      <div style="text-align:center;margin-top:20px;">
        <el-button @click="showLog=false">关闭</el-button>
      </div>
    </el-dialog>

    <detect-result :results="detectResults" :visible="showDetectResult" @closeBox="showDetectResult=false"/>

    <el-dialog title="以下配置文件不一致"
               :visible="showDifferentConfigs"
               @close="showDifferentConfigs=false">
      <el-row v-for="(con, index) in configsDifferent" :key="index">
        <div>
          <el-col :span="6">
            <h3>{{ con.moduleType }}</h3>
          </el-col>
          <el-col :span="18">
            <h3>{{ con.moduleVersion }}</h3>
          </el-col>
        </div>

        <div v-for="(file, idx) in con.modulesFiles" :key="idx">
          <el-col :span="6">{{ file.fileName }}</el-col>
          <el-col :span="18">{{ file.location }}</el-col>
        </div>
      </el-row>
    </el-dialog>
    <el-dialog
      title="增量升级"
      :visible.sync="dialogCoverFileVisible"
      @close="dialogCoverFileVisible=false"
      width="50%"
    >

      <el-upload
        style="display: inline-block;margin: 0 10px;"
        ref="upload"
        :on-success="handleSuccess"
        :on-error="handleError"
        :action="(baseUrl3+'config/getFilePath')"
        :show-file-list="false"
        name="filePart"
        :data="{
        instanceId:coverObj.id,
        moduleName:coverObj.moduleType,
        moduleVersion:coverObj.moduleVersion
        }"
        :headers="{
              Authorization: 'Bearer ' + token
            }"
      >
        <el-button size="mini" type="primary" v-if="btnInList('instance_upgrade_upload')">上传</el-button>
      </el-upload>
      <div style="margin-left: 10px;margin-top: 10px;">升级的文件名称:{{ this.fileName }}</div>
      <div style="margin-left: 10px;margin-top: 10px;">升级路径:{{ coverInfo }}

      </div>

      <div style="text-align:center;margin-top:20px;">
        <el-button v-if="coverInfo !== ''" size="mini" type="primary" @click="upLoadConfirm()">增量升级</el-button>
        <el-button size="mini" @click="dialogCoverFileVisible=false">取消升级</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加定时任务" :visible.sync="taskView">
      <el-form :model="taskForm">
        <el-form-item label="ID">
          <el-button type="text" style="margin-left: 50px">{{ taskInstanceId }}</el-button>
        </el-form-item>
        <el-form-item label="任务类型">
          <el-button type="text" v-if="taskType=='restart'" style="margin-left: 9px">重启</el-button>
          <el-button type="text" v-if="taskType=='update'" style="margin-left: 9px">更新</el-button>
        </el-form-item>
        <el-form-item label="执行时间">
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm"
            v-model="execTime"
            type="datetime"
            placeholder="选择执行时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="配置文件">
          <el-button type="primary" size="small" @click="chooseFile"
                     v-if="btnInList('instance_task_selectConfigFile')">选择配置文件
          </el-button>
          <span v-if="showTaskFile">
<el-table :data="taskFileList" style="width: 100%">
      <el-table-column prop="configName" label="文件名称" width="180"></el-table-column>
      <el-table-column prop="location" label="路径" width="180"></el-table-column>
    </el-table>
          </span>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="saveTask">确 定</el-button>
        <el-button @click="taskView = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="配置文件列表" :visible.sync="ListView">
      <el-table :data="fileListData" ref="taskFileTable"
                @selection-change="chooseTaskFile">
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column align="center" prop="name" label="文件名称"></el-table-column>
        <el-table-column align="center" prop="location" label="路径"></el-table-column>
        <el-table-column align="center" prop="version" label="版本号"></el-table-column>
        <el-table-column align="center" prop="function" label="描述"></el-table-column>
        <el-table-column align="center" prop="creator" label="创建者"></el-table-column>
      </el-table>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="saveSelectedFile">确 定</el-button>
        <el-button @click="ListView = false">取 消</el-button>
      </div>
    </el-dialog>
    <!--    默认端口-->
    <el-dialog title="默认端口" :visible.sync="defaultPortView" width="1200px">
      <!--      配置文件  配置项  端口 是否映射  协议  访问端口   唯一属性-->
      <el-form ref="portForm" :model="portForm" :inline="true">
        <div v-for="(item, idx) in portInfoList" :key="idx">
          <div style="margin-bottom: 10px" v-if="idx==0 || portInfoList[idx-1].name != item.name">{{ item.name }}</div>
          <!--          <el-form-item label="配置文件">-->
          <!--            <el-input v-model="item.name" disabled></el-input>-->
          <!--          </el-form-item>-->
          <el-form-item label="配置项">
            <el-input v-model="item.key" disabled></el-input>
          </el-form-item>
          <el-form-item label="端口">
            <el-input v-model.number="item.port" style="width: 80px"></el-input>
          </el-form-item>
          <el-form-item label="是否映射">
            <el-select v-model="item.mapping" placeholder="请选择" style="width: 70px">
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="协议">
            <el-select v-model="item.protocol" placeholder="请选择" style="width: 120px">
              <el-option label="UDP" :value="1"></el-option>
              <el-option label="TCP" :value="2"></el-option>
              <el-option label="UDP/TCP" :value="3"></el-option>
            </el-select>
            <!--            <el-input v-model="item.protocol"></el-input>-->
          </el-form-item>
          <el-form-item label="访问端口">
            <el-input v-model="item.requestAddr ? 'true' : 'false'" disabled style="width: 60px"></el-input>
          </el-form-item>
          <el-form-item label="唯一属性">
            <el-input v-model="item.attr" disabled></el-input>
          </el-form-item>
        </div>

      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="saveDefaultPort">确 定</el-button>
        <el-button @click="defaultPortView = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 实例复制 -->
    <copy-instance
      :visible="showCopyBox"
      :instanceId="currentRow.id"
      :serviceMode="currentRow.service.serviceMode"
      :containerType="currentRow.containerType"
      :copies="currentRow.copies"
      :deviceId="currentRow.deviceId"
      v-if="showCopyBox"
      @closeCopyBox="closeCopyBox"/>
  </div>
</template>
<script>
import {Loading} from "element-ui";
import ConfigList from "../../instance/ConfigList";
import LogList from "../log/LogList";
import {mapMutations, mapState} from 'vuex';
import DetectResult from "@/components/device/DeviceDetectResult"
import CopyInstance from '../CopyInstance'

export default {
  name: "ModuleInstanceList",
  components: {
    ConfigList,
    LogList,
    DetectResult,
    CopyInstance
  },
  props: {
    // 如果有设备信息,查看该设备下的实例列表，否则查询所有的
    device: {
      type: [String, Number]
    },
    // 如果有模块信息，查看该模块下的所有实例
    moduleType: {
      type: String
    },
    // 搜索字段
    search: {
      type: [String, Number]
    },
    searchCondition: {
      type: [String, Number]
    }
  },
  created() {
    this.getListOperations('moduleinstance');
    if (!this.currentMenu) {
      return
    }
    this.resetPage();
    this.initWebSocket();
    this.fromPath = this.$route.path
    // console.log( this.$route.path)
  },
  data: vm => ({
    portInfoList: [],
    portForm: {
      name: "",
      key: "",
      port: "",
      mapping: "",
      protocol: "",
      requestAddr: "",
      attr: ""
    },
    defaultPortView: false,
    isDocker: "",
    num: 0,
    dialogCoverFileVisible: false,
    taskView: false,
    ListView: false,
    coverInfo: '',
    fileName: '',
    lastModified: 0,
    taskForm: {},
    coverObj: {
      id: "",
      moduleName: '',
      moduleVersion: ''
    },
    showConfig: false,
    currentPage: 1,
    pageSize: 10,
    totalElement: 1,
    filterStatus: [
      {
        text: "已启动",
        value: 1
      },
      {
        text: "已停止",
        value: 3
      }
    ],
    filterHeart: [
      {
        text: "心跳已连接",
        value: 1
      },
      {
        text: "心跳已中断",
        value: 3
      }
    ],
    listData: [],
    fileListData: [],
    currentRow: {id: "", version: "", name: "", containerType: ''},
    type: "1", //1.本地 2.远端
    connectState: false, // websocket是否连接成功
    reconnectTimes: 1, // 重连次数
    timeOutNum: null,// 定时器
    execTime: null,
    docker: false,
    //log
    showLog: false,
    log: {
      instanceId: '',
      serviceId: '',
      moduleType: '',
      moduleVersion: '',
      deviceId: ''
    },
    fromPath: null,
    detectResults: [],//启动前端口探测结果
    showDetectResult: false,
    // docInstanceId:"",
    configsDifferent: [],
    showDifferentConfigs: false,
    showCopyBox: false, //显示复制弹框
    wsId: "",
    taskInstanceId: "",
    taskType: "",
    newInstanceId: null,
    currentTime: "",
    config: "",
    taskmoduleVersion: "",
    taskmoduleName: "",
    taskLocation: "",
    taskName: "",
    taskFileList: [],
    showTaskFile: false,
    selectedFile: "",
    fileServiceName: "",
  }),
  computed: {
    ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
    token() {
      return localStorage.getItem('token')
    },
    // listDataFilter() {
    //   let arr = this.filterArr(this.search, this.listData);
    //   // this.totalElement = arr.length;
    //   // let start = (this.currentPage - 1) * this.pageSize;
    //   // let end = this.currentPage * this.pageSize;
    //   // let listArr = arr.slice(start, end);
    //   return arr
    // },
    // 操作按钮是否可以显示
    btnInList() {
      return (name, childName) => {
        let btn = this.listOperations.filter(op => op.name.includes(name));
        if (!childName) {
          return btn.length > 0
        } else {
          return btn.some(childOp => childOp.name.includes(childName))
        }

      }
    },
  },
  watch: {
    // search: {
    //   handler(newValue, oldValue) {
    //     if (newValue != oldValue) {
    //       this.currentPage = 1
    //     }
    //   }
    // }
  },
  methods: {
    ...mapMutations(['getListOperations']),
    defaultPort(row) {
      if (row.nodeId == 0) {
        this.$message({showClose: true, message: "当前实例未上线，未获取到业务ID", type: "warn"});
        return;
      }
      this.defaultPortView = true;
      this.currentRow = row;
      this.getPortInfo(row)
    },
    saveDefaultPort() {
      let data = {
        "nodeId": this.currentRow.nodeId,
        "moduleType": this.currentRow.moduleType,
        "list": this.portInfoList
      }
      this.$axios.post(this.baseUrl3 + 'config/default/port/save', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.defaultPortView = false;
          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getPortInfo(row) {
      let url = this.baseUrl3 + "config/default/port/" + row.moduleType + "/" + row.nodeId;
      this.$axios.get(url)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data && data.length > 0) {
              this.portInfoList = data;
            } else {
              this.portInfoList = [];
            }
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        }).catch(err => {
        console.log(err)
      });
    },
    restartAgent(row) {
      this.$confirm('是否确定重启当前service_agent？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.get(this.baseUrl3 + "deploy/device/agent/restart/" + row.deviceId)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.$message.success("任务下发成功！")
            } else {
              this.$message({showClose: true, message: msg, type: "error"});
              console.log(msg);
            }
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    chooseTaskFile(val) {
      this.taskFileList = [];
      let arr = [];
      arr = this.$refs["taskFileTable"].selection;
      arr.forEach(e => {
        this.taskFileList.push({
          location: e.location + "",
          configName: e.name,
        })
      });
      this.selectedFile = JSON.stringify(this.taskFileList);
    },
    saveSelectedFile() {
      this.showTaskFile = true;
      this.ListView = false;
    },
    chooseFile() {
      this.ListView = true;
      if (this.docker) {
        this.getDockerConfigList()
      } else {
        this.getAllConfigList()
      }
    },
    getAllConfigList() {
      if (!this.taskmoduleName || !this.taskmoduleVersion) {
        return;
      }
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.fileListData = [];
      this.$axios
        .get(
          this.moduleUrl +
          "config/get/listByNameAndVersion/" +
          this.taskmoduleName +
          "/" +
          this.taskmoduleVersion
        )
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            data.forEach(d => {
              if (!d.location) {
                d.location = null
              }
              if (d.name.indexOf(".service") != -1) {
                d.name = this.fileServiceName + ".service";
              }
            });
            this.fileListData = data;
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close();
        });
    },
    getDockerConfigList() {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.fileListData = [];
      let url = this.baseUrl3 + "config/cat/all/" + this.taskInstanceId;
      this.$axios.get(url)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data && data.length > 0) {
              data.forEach(d => {
                if (!d.location) {
                  d.location = null
                }
              });
              this.fileListData = data;
            } else {
              this.$message({showClose: true, message: "当前模块没有配置文件", type: "warn"});
            }
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close();
        });
    },
    addTask(row) {
      this.fileServiceName = row.service.name;
      this.taskView = true;
      this.taskInstanceId = row.id;
      this.taskType = "restart";
      this.taskmoduleVersion = row.moduleVersion;
      this.taskmoduleName = row.moduleType;
      this.docker = row.isDocker;
      this.execTime = null;
      this.taskFileList = [];
      this.showTaskFile = false;
    },
    saveTask() {
      let data = {
        instanceId: this.taskInstanceId,
        newInstanceId: this.newInstanceId,
        taskType: this.taskType,
        execTime: this.execTime,
        config: this.selectedFile
      };
      this.currentTime = new Date().Format('yyyy-MM-dd hh:mm:ss');
      let currentT = new Date(this.currentTime).getTime() / 1000;
      let execT = new Date(this.execTime).getTime() / 1000;
      if (execT < currentT + 600) {
        this.$message.error('执行时间需晚于当前时间十分钟！');
        return
      }
      let _this = this;
      this.$axios.post(this.baseUrl3 + 'deploy/timerTask/addTask', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.taskView = false;
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getDockerState(row) {
      row.createLoading = true;
      let data = {
        "dockerName": row.dockerDto.containerName,
        "instanceId": row.id
      };
      this.$axios.post(this.baseUrl3 + 'management3/instance/findByDockerName', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            row.createLoading = false;
            if (data) {
              if (data.instanceId == row.id) {
                let docInstanceId = row.dockerDto.containerId.substring(0, 10);
                this.$confirm('当前实例绑定的容器[' + docInstanceId + ']处于运行状态，是否销毁旧的容器创建新的容器？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.stop(row, data.instanceId);
                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消'
                  });
                });
              } else {
                let dataInstanceId = data.dockerId.substring(0, 10);
                this.$confirm('当前设备上容器名是[' + data.dockerName + '][' + dataInstanceId + ']的正跟实例[' + data.instanceId + ']处于绑定关系，如果执行当前操作，会使实例[' + data.instanceId + ']的状态处于停止状态并销毁旧容器[' + dataInstanceId + ']这样的操作有可能会导致平台不能提供正常服务。', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.stop(row, data.instanceId);
                  row.createLoading = false;
                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消'
                  });
                  row.createLoading = false;
                });
              }
            } else {
              row.createLoading = false;
              this.createDocker(row);
            }
          } else {
            row.createLoading = false;
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    createDocker(row) {
      row.createLoading = true;
      this.$axios.get(this.baseUrl3 +
        "management3/deploy/docker/create/" + row.id)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            row.createLoading = false;
            this.$message({showClose: true, message: "容器创建成功！", type: "success"});
          } else {
            row.createLoading = false;
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          row.createLoading = false;
        })
        .catch(err => {
          row.createLoading = false;
          console.log(err);
        });
    },
    upLoadConfirm(type, row) {
      this.$confirm('请确认服务已关闭?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.upload()
      }).catch(() => {

      });
    },
    upload() {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据保存中..."
      });
      this.$axios
        .get(this.baseUrl3 + 'config/replaceFile/' + this.coverObj.id + "/"
          + this.coverObj.moduleType + "/" + this.coverObj.moduleVersion + "/" + this.fileName + "/"
          + encodeURIComponent(encodeURIComponent(this.coverInfo)) + "/" + this.lastModified)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.dialogCoverFileVisible = false;
            this.$message.success("增量升级成功,查看结果描述信息后,重启服务!!!");
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close()
        }).catch(err => {
        loading.close();
        this.$message.error('请求失败！')
      });
    },
    coverStart(row) {
      this.coverInfo = '';
      this.fileName = '';
      this.lastModified = 0;
      this.coverObj = row;
      this.dialogCoverFileVisible = true;
    },
    // 文件上传
    handleSuccess({code, msg, data}, file, fileList) {
      this.fileName = file.name;
      this.lastModified = file.raw.lastModified;
      if (code == 20000) {
        if (data.length == 1) {
          this.coverInfo = data[0];
          this.$message.success("上传成功");
        } else {
          this.$message.error("上传错误!存在多个路径或者不存在任何一个路径");
        }
      } else {
        this.$message.error("上传失败！原因：" + msg);
      }
    },
    handleError(err, file, fileList) {
      this.$message({showClose: true, message: "上传失败", type: "error"});
      console.log("error=" + err);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.resetPage();

    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.resetPage();
    },
    stop(row, instanceId) {
      this.$axios
        .get(this.baseUrl3 + 'deploy/stop' + "/" + instanceId)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.createDocker(row);
          } else {

          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    start(row, url) {
      this.$axios
        .get(this.baseUrl3 + 'deploy/' + url + "/" + row.id)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            // 展示哪些配置文件不一致
            this.$message.success('下发任务成功')
          } else {
            if (code == 10034) {
              this.detectResults = data;
              this.showDetectResult = true
            } else if (code == 10030 && data && data.length > 0) {
              this.showDifferentConfigs = true;
              this.configsDifferent = data
            }
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    filterHandle(value, row, column) {
      const property = column["property"];
      return row[property] == value;
    },
    getResetPage() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.resetPage()
    },
    resetPage() {
      let data = {}
      if (this.searchCondition == null) {
        data = {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          // deviceId: this.device,
          condition: this.search,
          // type: this.searchCondition,
          // moduleType: this.moduleType
        };
      } else {
        let obj = {}
        obj[this.searchCondition] = this.search;
        data = {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          keyword: obj,
        };
      }
      if (this.device) {
        data.deviceId = this.device;
      }
      if (this.moduleType) {
        data.moduleType = this.moduleType;
      }
      this.$axios.post(this.baseUrl3 + "instance/installed/list/page", data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data.list && data.list.length > 0) {
              let arr = [];
              data.list.forEach(e => {
                arr.push(e.id)
              });
              this.wsId = arr.join(',');
              this.websocketsend(this.wsId);
              this.totalElement = data.total;
              this.listData = this.convertToUiData(data.list);
            } else {
              this.listData = [];
              this.totalElement = 0
            }

          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        }).catch(err => {
        console.log(err)
      })
    },
    convertToUiData(data) {
      let arr = [];
      if (data.length == 0) {
        return;
      }
      data.forEach(d => {
        let obj = {
          startStatus: 3,
          heartStatus: 3
        };
        // startStatus启动状态: 1.启动成功(已启动) 2.启动失败 3.停止成功(已停止) 4.停止失败 5.正在启动 6.正在停止
        // heartStatus心跳状态：1.心跳连接成功 2.心跳连接失败 3.心跳中断成功 4.心跳中断失败 5.正在心跳连接 6.正在心跳中断
        if (d.service.status.progress == 4) {
          obj.startStatus =
            d.service.status.value == 1
              ? 1
              : d.service.status.value == 2
                ? 2
                : 5;
        } else if (d.service.status.progress == 5) {
          obj.startStatus =
            d.service.status.value == 1
              ? 3
              : d.service.status.value == 2
                ? 4
                : 6;
        } else if (d.service.status.progress == 6) {
          obj.startStatus = 1;
          obj.heartStatus =
            d.service.status.value == 1
              ? 1
              : d.service.status.value == 2
                ? 2
                : 5;
        } else if (d.service.status.progress == 10) {
          obj.startStatus = 1;
          obj.heartStatus =
            d.service.status.value == 1
              ? 3
              : d.service.status.value == 2
                ? 4
                : 6;
        } else if (d.service.status.progress == 13) {
          // 心跳连接发送
          obj.startStatus = 1;
          // obj.heartStatus = 5;
          if (d.service.status.value == 2) {
            obj.heartStatus = 2
          } else if (d.service.status.value == 0) {
            obj.heartStatus = 5
          }
        } else if (d.service.status.progress == 14) {
          // 心跳断开发送
          obj.startStatus = 1;
          if (d.service.status.value == 2) {
            obj.heartStatus = 4
          } else if (d.service.status.value == 0) {
            obj.heartStatus = 6
          }
        }
        arr.push(Object.assign(obj, d));
      });
      //   this.listData = arr;
      return arr;
    },
    handleCommand(command) {
      this.currentRow = {
        id: command.row.id,
        serviceName: command.row.service.name,
        start: command.row.service.status.operation.start,
        name: command.row.moduleType,
        version: command.row.moduleVersion,
        hasServiceHelper: command.row.hasServiceHelper
      };
      this.type = command.type;
      this.showConfig = true;
      this.docker = command.row.isDocker;

    },
    showLogSummary(row) {
      this.log.instanceId = row.id;
      this.log.serviceId = row.service.id;
      this.log.moduleType = row.moduleType;
      this.log.moduleVersion = row.moduleVersion;
      this.log.deviceId = row.deviceId;
      this.showLog = true;
    },
    /**
     * 连接websocket
     */
    initWebSocket() {
      //const url = this.baseUrl.split('http://')[1]
      //初始化weosocket
      //const wsuri = "ws://" + url + "monitor";
      let url = "";
      let wsuri = "";
      if (this.baseUrl3.indexOf('https://') != -1) {
        url = this.baseUrl3.split('https://')[1];
        wsuri = "wss://" + url + "monitor";
      } else {
        url = this.baseUrl3.split('http://')[1];
        //初始化weosocket
        wsuri = "ws://" + url + "monitor";
      }
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      //连接建立之后执行send方法发送数据
      console.log("open");
      this.connectState = true;
    },
    websocketonerror() {
      //连接建立失败重连
      // webSocket 断开连接 连接状态 重置
      this.connectState = false;
      // 大于9 次, 不再重连
      // if (this.reconnectTimes <= 9) {
      this.reconnect();
      // }
    },
    websocketsend(data) {
      if (this.connectState == true) {
        this.websock.send(data);
      }
    },
    websocketonmessage(e) {
      //数据接收
      if (e) {
        // 获取到的对象不为空
        if (e.data != null && Object.keys(e.data).length != 0) {
          let data = JSON.parse(e.data);
          // console.log("monitor-websocket-message:");
          // console.log(data);
          // console.log((this.num++) +JSON.stringify(data));
          const _this = this;
          for (let i = 0; i < _this.listData.length; i++) {
            const tr = _this.listData[i];
            if (tr.id == data.insId) {
              let item = {
                service: {
                  serviceMode: data.serviceMode,
                  status: data,
                  name: data.name
                }
              };
              if (data.serviceId) {
                item.service.id = data.serviceId
              }
              // const arr = _this.convertToUiData([item])
              // _this.$set(_this.listData, i, Object.assign(tr, arr[0]))
              // 启动成功或心跳中断后隔10秒才能再次点击心跳连接
              if (data.progress == 4 && data.value == 1 ||
                data.progress == 10 && data.value == 1) {
                item.heartbeatDisabled = true;
                setTimeout(() => {
                  // item.heartbeatDisabled = false
                  _this.listData[i].heartbeatDisabled = false;
                  _this.$set(_this.listData, i, _this.listData[i])
                }, 10000)
              }
              _this.$set(_this.listData, i, Object.assign(tr, item));
              break
            }
          }
        }
      }
    },
    websocketclose(e) {
      //关闭
      console.log("断开连接", e);
      this.connectState = false;
      // 大于9 次, 不再重连
      if (this.reconnectTimes <= 9) {
        this.reconnect();
      }
    },
    /**
     * 断线重连
     */
    reconnect() {
      // 连接断开时, 进行重连
      if (!this.connectState) {
        // 连接次数
        let i = this.reconnectTimes;
        let _this = this;
        // 清除之前的定时器
        if (_this.timeOutNum != null) {
          clearTimeout(_this.timeOutNum); //去掉定时器
        }
        // 1,2,3 前三次 1秒重连一次
        if (i <= 3) {
          _this.timeOutNum = setTimeout(() => {
            _this.initWebSocket();
          }, 1000);
        } else if (i <= 6 && i > 3) {
          // 4,5,6 等待30s 30s重连一次
          _this.timeOutNum = setTimeout(() => {
            _this.initWebSocket();
          }, 30000);
        } else if (i > 6) {
          // 7,8,9 等待60s 60s重连一次
          _this.timeOutNum = setTimeout(() => {
            _this.initWebSocket();
          }, 60000);
        }
        // 连接次数 +1
        this.reconnectTimes = ++this.reconnectTimes;
      }
    },
    // 实例启动前探测
    detectBeforeStart(row) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.$axios
        .get(this.baseUrl3 + 'instance/detectPort/' + row.id)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            // if(data.length == 0){
            //     this.$message.success('端口未被占用，可以启动了！')
            // }else{
            //     this.detectResults = data
            //     this.showDetectResult = true
            // }
            this.$message.success('端口未被占用，可以启动了！')
          } else {
            if (code == 10034) {
              this.detectResults = data;
              this.showDetectResult = true
            } else if (code == 10030 && data && data.length > 0) {
              this.showDifferentConfigs = true;
              this.configsDifferent = data
            }
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close();
        })
        .catch(err => {
          loading.close();
          console.log(err);
        });
    },
    getNodeId(row) {
      let data = {
        instanceId: row.id,
        moduleType: row.moduleType
      };
      this.$axios.post(this.baseUrl3 + 'management3/node/findByInsId', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data) {
              this.dockerSyncToV3(row, data.nodeId)
              // this.nodeId = data.nodeId;
            } else {
              this.$message.warning("当前实例未绑定业务ID！")
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    //同步到v3
    syncToV3(row) {
      if (row.isDocker) {
        this.getNodeId(row)
      } else {
        this.sync(row)
      }
    },
    sync(row) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.$axios
        .get(this.baseUrl3 + 'instance/syncInstance/' + row.id)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.$message.success('同步到V3成功！');
            row.sync = true
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close();
        })
        .catch(err => {
          loading.close();
          console.log(err);
        });
    },
    dockerSyncToV3(row, nodeId) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      let data = {
        deviceId: row.deviceId,
        instanceId: row.id,
        moduleType: row.moduleType,
        nodeId: nodeId
      }
      this.$axios
        .post(this.baseUrl3 + 'management3/addr/docker/sync', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.$message.success('同步到V3成功！');
            row.sync = true
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close();
        })
        .catch(err => {
          loading.close();
          console.log(err);
        });
    },
    // 实例复制
    copyInstance(row) {
      this.showCopyBox = true;
      this.currentRow = row
    },
    closeCopyBox(val) {
      this.showCopyBox = false;
      if (val == 'copy') {
        this.resetPage()
      }
    },
  }
};
</script>
<style scoped>
.divCon {
  width: 40%;
  margin: 20px 0px;
}

.statusIcon {
  font-size: 30px;
}
</style>
